import http from '@/utils/http';

export type TAuthPathResId = 'dashboard_pc' | 'studio_hub' | 'benchmark' | string;

export interface IAuthPathTokenParams {
  res_id: TAuthPathResId;
  game_code?: string;
  studio_code?: string;
  menu_id: string;
  page_type: string;
  page_value?: string;
  path?: string;
}

export interface IAuthPathTokenData {
  token: string;
}

export const getAuthPathToken = (
  data: IAuthPathTokenParams,
): Promise<IBaseResponse<IAuthPathTokenData | null>> => {
  return http({
    url: '/api/v1/dashboard/auth_path_token',
    method: 'post',
    data,
    rawData: true,
  }) as any;
};

export const getUtilAuthToken = (
  data: IAuthPathTokenParams,
): Promise<IBaseResponse<IAuthPathTokenData | null>> => {
  return http({
    url: '/api/v1/util/auth/gettoken',
    method: 'post',
    data: {
      url: data.page_value || data.path || '',
      payload: {
        res_id: data.res_id,
        menu_id: data.menu_id,
        page_type: data.page_type,
      },
    },
    rawData: true,
  }) as any;
};